var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import _ from "lodash";
import { ListHeader, ListRow } from "../List";
import { getColumnWidthClassName } from "../table/tableUtils";
import { classNames } from "../utils/classNames";
import { isDefined } from "../utils/isDefined";
import parseChildren from "../utils/parseChildren";
import { COL_PIXEL_MAP } from "../utils/sizing";
export var buildGridColumnWidthToString = function (columns) {
    return columns.reduce(function (gridColumns, column) { return gridColumns + " " + COL_PIXEL_MAP.get(column); }, "");
};
export var getListCellContentClassNames = function (link, tooltip) {
    return classNames("list__cell--text", "list__cell--value", link ? "link" : "", tooltip ? getColumnWidthClassName(tooltip.width) : "");
};
export var getGridColumns = function (gridColumns) {
    if (gridColumns && typeof gridColumns !== "string") {
        gridColumns = buildGridColumnWidthToString(gridColumns);
    }
    return gridColumns;
};
export var warnIfWidthArrayNotSet = function (listChildren) {
    var warnForRow = false;
    var warnForHeader = false;
    var listRow = listChildren.filterByType(ListRow);
    if (Array.isArray(listRow)) {
        listRow.forEach(function (item) {
            var _a;
            if (warnForRow === false && (item === null || item === void 0 ? void 0 : item.props)) {
                var listRowChildren = parseChildren((_a = item === null || item === void 0 ? void 0 : item.props) === null || _a === void 0 ? void 0 : _a.children);
                var listRowChildRow = listRowChildren.filterByType(ListRow);
                if (listRowChildRow.length > 0) {
                    listRowChildRow.forEach(function (childItem) {
                        if (warnForRow === false && (childItem === null || childItem === void 0 ? void 0 : childItem.props)) {
                            warnForRow = missingGridColumn(childItem === null || childItem === void 0 ? void 0 : childItem.props);
                        }
                    });
                }
                else {
                    warnForRow = missingGridColumn(item === null || item === void 0 ? void 0 : item.props);
                }
            }
        });
    }
    var listHeader = listChildren.findByType(ListHeader);
    warnForHeader = missingGridColumn(listHeader === null || listHeader === void 0 ? void 0 : listHeader.props);
    if (warnForRow || warnForHeader) {
        console.warn("[piston-ux] If you are using the prop \"contained\" on List you need to pass GridColumnWidth[] to".concat(warnForRow ? " ListRow" : "").concat(warnForRow && warnForHeader ? " and" : "").concat(warnForHeader ? " ListHeader" : "", " prop \"gridColumns\"."));
    }
};
export var missingGridColumn = function (props) {
    if (!props)
        return false;
    if (_.isEmpty(props))
        return false;
    return (props === null || props === void 0 ? void 0 : props.gridColumns) === undefined || !Array.isArray(props.gridColumns);
};
export function getListCellLinkAttributes(listCellLink, hasChidlren) {
    var _a, _b, _c, _d;
    var ListHTMLElement = "span";
    var linkAttributes = {};
    if ((listCellLink === null || listCellLink === void 0 ? void 0 : listCellLink.link) === undefined) {
        linkAttributes = {
            onClick: listCellLink === null || listCellLink === void 0 ? void 0 : listCellLink.onClick,
            onKeyPress: listCellLink === null || listCellLink === void 0 ? void 0 : listCellLink.onClick,
            "aria-label": listCellLink === null || listCellLink === void 0 ? void 0 : listCellLink.ariaLabel,
            role: hasChidlren
                ? (listCellLink === null || listCellLink === void 0 ? void 0 : listCellLink.onClick) && (listCellLink === null || listCellLink === void 0 ? void 0 : listCellLink.role) === undefined
                    ? "link"
                    : listCellLink === null || listCellLink === void 0 ? void 0 : listCellLink.role
                : "none",
            id: listCellLink === null || listCellLink === void 0 ? void 0 : listCellLink.id,
        };
    }
    else {
        if (isDefined((_a = listCellLink === null || listCellLink === void 0 ? void 0 : listCellLink.link) === null || _a === void 0 ? void 0 : _a.url)) {
            if ((_b = listCellLink === null || listCellLink === void 0 ? void 0 : listCellLink.link) === null || _b === void 0 ? void 0 : _b.routerLink) {
                ListHTMLElement = (_c = listCellLink === null || listCellLink === void 0 ? void 0 : listCellLink.link) === null || _c === void 0 ? void 0 : _c.routerLink;
                linkAttributes = {
                    href: listCellLink === null || listCellLink === void 0 ? void 0 : listCellLink.link.url,
                    to: listCellLink === null || listCellLink === void 0 ? void 0 : listCellLink.link.url,
                };
            }
            else {
                ListHTMLElement = "a";
                linkAttributes = __assign({ href: (_d = listCellLink === null || listCellLink === void 0 ? void 0 : listCellLink.link) === null || _d === void 0 ? void 0 : _d.url }, (listCellLink.link.newTab
                    ? { target: "_blank", rel: "noopener noreferrer" }
                    : {}));
            }
        }
    }
    return { ListHTMLElement: ListHTMLElement, linkAttributes: linkAttributes };
}
export function getListLinkAttributes(link) {
    var linkAttributes = {};
    if (link === null || link === void 0 ? void 0 : link.routerLink) {
        linkAttributes = {
            href: link.url,
            to: link.url,
        };
    }
    else {
        linkAttributes = {
            href: link === null || link === void 0 ? void 0 : link.url,
        };
    }
    return linkAttributes;
}
export var getTabIndex = function (initialise, index, indexOffset) {
    if (!initialise) {
        return undefined;
    }
    var columnNumber = index + indexOffset;
    return columnNumber === 1 ? 0 : undefined;
};
